import { IBondGelemReport } from 'services/bonds-helper';

export const PREFIX = 'REPORT_YIELD_SHEKEL';

export type IReportYieldShekelItem = IBondGelemReport & { __isSelected: boolean };
